//export const Base_URL =  "https://api.dealkarts.in/"
// export const Base_URL =  "http://localhost:8909/"

//Server
//export const Base_URL =  "http://91.203.135.63:9877/api/v1"
//export const Socket_Base_URL =  "http://91.203.135.63:9877"
export const Base_URL =  "https://api-central.examstream.in/api/v1"
export const Socket_Base_URL =  "https://api-central.examstream.in"

//Local
//export const Base_URL =  "http://localhost:9000/api/v1"
//export const Socket_Base_URL =  "http://localhost:9000"

